var exports = {
  "v": "banner__4HXDNo",
};

module.exports = exports;
